"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ButtonLoadingIndicator;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const variables_1 = __importDefault(require("../../styles/variables"));
const useStyles = (0, core_1.makeStyles)({
    loadingStage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        padding: '0.7rem 0',
        margin: '0 -5%',
        overflow: 'hidden',
        color: variables_1.default.colors.white,
        width: '100%',
    },
    loadingDots: {
        position: 'relative',
        left: '-9999px',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: variables_1.default.colors.white,
        boxShadow: `0 0 0 -5px ${variables_1.default.colors.white}`,
        animation: '$dotPulse 1.5s infinite linear',
        animationDelay: '0.25s',
        '&::before': {
            content: "''",
            display: 'inline-block',
            position: 'absolute',
            top: 0,
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: variables_1.default.colors.white,
            boxShadow: `9981px 0 0 -5px ${variables_1.default.colors.white}`,
            animation: '$dotPulseBefore 1.5s infinite linear',
            animationDelay: '0s',
        },
        '&::after': {
            content: "''",
            display: 'inline-block',
            position: 'absolute',
            top: 0,
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: variables_1.default.colors.white,
            boxShadow: `10007px 0 0 -5px ${variables_1.default.colors.white}`,
            animation: '$dotPulseAfter 1.5s infinite linear',
            animationDelay: '0.5s',
        },
    },
    '@keyframes dotPulseBefore': {
        '0%': { boxShadow: `9981px 0 0 -5px ${variables_1.default.colors.white}` },
        '30%': { boxShadow: `9981px 0 0 2px ${variables_1.default.colors.white}` },
        '60%': { boxShadow: `9981px 0 0 -5px ${variables_1.default.colors.white}` },
        '100%': { boxShadow: `9981px 0 0 -5px ${variables_1.default.colors.white}` },
    },
    '@keyframes dotPulse': {
        '0%': { boxShadow: `9999px 0 0 -5px ${variables_1.default.colors.white}` },
        '30%': { boxShadow: `9999px 0 0 2px ${variables_1.default.colors.white}` },
        '60%': { boxShadow: `9999px 0 0 -5px ${variables_1.default.colors.white}` },
        '100%': { boxShadow: `9999px 0 0 -5px ${variables_1.default.colors.white}` },
    },
    '@keyframes dotPulseAfter': {
        '0%': { boxShadow: `10007px 0 0 -5px ${variables_1.default.colors.white}` },
        '30%': { boxShadow: `10007px 0 0 2px ${variables_1.default.colors.white}` },
        '60%': { boxShadow: `10007px 0 0 -5px ${variables_1.default.colors.white}` },
        '100%': { boxShadow: `10007px 0 0 -5px ${variables_1.default.colors.white}` },
    },
});
function ButtonLoadingIndicator() {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.loadingStage, "data-testid": "loadingIndicator" },
        react_1.default.createElement("div", { className: classes.loadingDots })));
}
